export default __webpack_public_path__ + "42402557a729302627f66a3b3c435094.jpg";